import React from 'react';
import {
    PanelHeader,
    PanelHeaderButton,
    Div,
    SplitCol,
    SplitLayout,
    Button, ButtonGroup, Chip, Title,
    ModalRoot, ModalPage, ModalPageHeader,
    SimpleCell
} from '@vkontakte/vkui';

import {
    Icon16Clear,
    Icon20ListPenOutline,
    Icon24Cancel,
    Icon24QuestionOutline,
    Icon24Video
} from "@vkontakte/icons";

import {AdaptivityContext, getImageAngles, setQuizStep} from "../assets/constants";
import "./style.css"

import BaseComponent from "../components/BaseComponent";
import withOffline from "../components/withOffline";
import SalePointMonitoringDocsApi from "../api/SalePointMonitoringDocs";
import HelpButton from "../assets/HelpButton";
import TakeAVideo from "../components/TakeAVideo";
import VideoWrapper from "../utils/VideoWrapper";
import PDFViewer from "../assets/PDFViewer";

const MODAL_VIDEO_HELP = 'modal_video_help';
const MODAL_VIDEO_INSTRUCTION = 'modal_video_instruction';
const MODAL_CHANGE_VIDEO_ANGLE = 'modal_change_video_angle';
const MONITORING_DOC_TYPE = 'sale_point_monitoring';


class SalePointMonitoringStepVideo extends BaseComponent {

    handleVideosChange = (updatedVideos) => {
        const {current_document} = this.props;
        if (!current_document || !current_document.doc_data) return;

        current_document.doc_data.videos = updatedVideos;
        window.postMessage({type: 'setCurrentSaleDocMonitoring', value: current_document});

        // Persist to server only when the document already exists
        if (current_document.doc_data.id && current_document.doc_data.id > 0) {
            SalePointMonitoringDocsApi.setVideos({
                doc_id: current_document.doc_data.id,
                videos: JSON.stringify(updatedVideos)
            });
        }
        setTimeout(() => this.setState({}), 100);
    }

    getVideoAngles = () => {
        const anglesRaw = getImageAngles() || {};
        return Object.values(anglesRaw).filter(a =>
            a && a.doc_type === MONITORING_DOC_TYPE && a.media_type === 'video'
        );
    }

    countAngleVideos = (videos, angleId) => {
        return (videos || []).filter(v => v && Number(v.angle_id ?? 0) === Number(angleId)).length;
    }

    getVideosForAngle = (videos, angleId) => {
        return (videos || [])
            .map((item, index) => ({item, index}))
            .filter(({item}) => Number(item.angle_id ?? 0) === Number(angleId));
    }

    getFirstAngleCoverUrl = (videos, angle, videosUrl) => {
        const first = (videos || []).find(v =>
            v && Number(v.angle_id ?? 0) === Number(angle.id)
        );
        if (first && first.video) {
            return {type: 'video', url: videosUrl + first.video};
        }
        // Examples stay in the help modal, not as tile covers.
        return null;
    }

    toggleAngleExpanded = (angleId) => {
        const current = this.state.expandedAngleId;
        this.setState({expandedAngleId: Number(current) === Number(angleId) ? null : Number(angleId)});
    }

    openAngleInstruction = (angle) => {
        this.setState({currentInstructionAngle: angle});
        this.setActiveModal(MODAL_VIDEO_INSTRUCTION);
    }

    openAngleHelp = (angle) => {
        this.setState({currentInstructionAngle: angle});
        this.setActiveModal(MODAL_VIDEO_HELP);
    }

    hasAngleHelp = (angle) => {
        const hasExamples = Array.isArray(angle.examples) && angle.examples.length > 0;
        return hasExamples || !!angle.instruction_pdf;
    }

    openChangeVideoAngle = (index) => {
        this.setState({changeVideoIndex: index});
        this.setActiveModal(MODAL_CHANGE_VIDEO_ANGLE);
    }

    applyChangeVideoAngle = (angleId) => {
        const {current_document} = this.props;
        const index = this.state.changeVideoIndex;
        if (index === null || index === undefined || !current_document?.doc_data) {
            this.setActiveModal(null);
            return;
        }
        const videos = [...(current_document.doc_data.videos ?? [])];
        if (videos[index]) {
            videos[index] = {...videos[index], angle_id: Number(angleId)};
            this.handleVideosChange(videos);
        }
        this.setState({changeVideoIndex: null});
        this.setActiveModal(null);
    }

    receiveMessage = (event) => {
        if (event.data.type === 'setSalePointMonitoringVideo'
            || (typeof event.data.type === 'string' && event.data.type.startsWith('setSalePointMonitoringVideo_angle_'))) {
            const {current_document, base_url} = this.props;
            if (!current_document || !current_document.doc_data) return;

            const videos_url = base_url.replace("frontend/", '');
            const videos = Array.isArray(current_document.doc_data.videos)
                ? [...current_document.doc_data.videos] : [];

            videos.push({
                video: event.data.data.video.replace(videos_url, ''),
                filename: event.data.data.filename,
                angle_id: event.data.data.angle_id ?? 0,
                datetime: new Date()
            });
            this.handleVideosChange(videos);
        }
        if (event.data == 'SalePointMonitoringGoGetBack') {
            setQuizStep(2, 'SalePointMonitoring');
        }
    }

    deleteVideo = (index) => {
        const {current_document} = this.props;
        const videos = [...(current_document.doc_data.videos ?? [])];
        videos.splice(index, 1);
        this.handleVideosChange(videos);
    }

    nextStep = () => {
        const {current_document} = this.props;
        const videos = current_document.doc_data && Array.isArray(current_document.doc_data.videos)
            ? current_document.doc_data.videos : [];

        let errors = 0;
        this.getVideoAngles().forEach(angle => {
            if (Number(angle.required) !== 1) return;
            const need = Math.max(1, Number(angle.min_count) || 0);
            const cnt = this.countAngleVideos(videos, angle.id);
            if (cnt < need) {
                errors++;
                window.postMessage({
                    type: 'error',
                    text: `Ракурс «${angle.title}»: нужно минимум ${need} видео (снято ${cnt})`
                });
            }
        });

        if (errors === 0) {
            setQuizStep(4, 'SalePointMonitoring');
        }
    }

    openGreenCamera = () => {
        const ref = this.freeformVideoRef || this.noAngleVideoRef;
        if (ref && typeof ref.openCapture === 'function') {
            ref.openCapture();
        }
    }

    renderVideoCard = (item, index, angles) => {
        const {base_url} = this.props;
        const videos_url = base_url.replace("frontend/", '');
        return (
            <div key={`video-${index}`} style={{position: 'relative'}}>
                <VideoWrapper
                    src={videos_url + item.video}
                    width={AdaptivityContext.isMobile ? 160 : 220}
                />
                <ButtonGroup mode="horizontal" style={{position: 'absolute', top: 8, left: 8, gap: 4}}>
                    {angles.length > 0 &&
                        <Button mode="primary" size="m" className="btn-gallery-actions"
                                onClick={() => this.openChangeVideoAngle(index)}
                                before={<Icon20ListPenOutline/>}
                                aria-label="Сменить ракурс"
                        />}
                    <Button mode="primary" size="m" className="btn-gallery-actions"
                            onClick={() => this.deleteVideo(index)}
                            before={<Icon16Clear/>}
                    />
                </ButtonGroup>
            </div>
        );
    }

    renderAngleTile = (angle, videos, videosUrl) => {
        const need = Number(angle.min_count) || 0;
        const cnt = this.countAngleVideos(videos, angle.id);
        const isRequired = Number(angle.required) === 1;
        const complete = isRequired && cnt >= Math.max(1, need);
        const incomplete = isRequired && !complete;
        const watermark = isRequired && need > 0 ? `${cnt} из ${need}` : String(cnt);
        const cover = this.getFirstAngleCoverUrl(videos, angle, videosUrl);
        const isActive = Number(this.state.expandedAngleId) === Number(angle.id);

        let titleClass = 'angle-tile__title';
        if (incomplete) titleClass += ' angle-tile__title--need';
        else if (complete) titleClass += ' angle-tile__title--ok';
        else titleClass += ' angle-tile__title--neutral';

        return (
            <div
                key={`vangle-tile-${angle.id}`}
                className={`angle-tile${isActive ? ' angle-tile--active' : ''}`}
                onClick={() => this.toggleAngleExpanded(angle.id)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.toggleAngleExpanded(angle.id);
                    }
                }}
            >
                <div className={titleClass}>{angle.title}</div>
                <div className="angle-tile__cover">
                    {cover
                        ? <VideoWrapper src={cover.url} fill/>
                        : <div className="angle-tile__cover-empty" aria-hidden="true"/>}
                    <div className="angle-tile__watermark">{watermark}</div>
                </div>
            </div>
        );
    }

    renderExpandedAngle = (angle, videos, videosUrl) => {
        if (!angle) return null;
        const angles = this.getVideoAngles();
        const angleVideos = this.getVideosForAngle(videos, angle.id);

        return (
            <div className="angle-expanded">
                <div className="angle-expanded__toolbar">
                    {this.hasAngleHelp(angle) &&
                        <Button mode="tertiary" size="s"
                                before={<Icon24QuestionOutline width={22} height={22}/>}
                                onClick={() => this.openAngleHelp(angle)}
                                aria-label="Как снимать"/>}
                    <div className="angle-expanded__title">{angle.title}</div>
                </div>
                <div style={{display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 8}}>
                    {angleVideos.map(({item, index}) => this.renderVideoCard(item, index, angles))}
                </div>
                <div style={{marginTop: 8}}>
                    <TakeAVideo
                        destination="brands"
                        url={videosUrl}
                        angleId={angle.id}
                        angles={angles}
                        eventName={`setSalePointMonitoringVideo_angle_${angle.id}`}
                        label={`Снять видео: ${angle.title}`}
                    />
                </div>
            </div>
        );
    }

    render() {
        const {current_document, base_url} = this.props;
        const videosUrl = base_url.replace("frontend/", '');

        const videos = current_document.doc_data && Array.isArray(current_document.doc_data.videos)
            ? current_document.doc_data.videos : [];
        const angles = this.getVideoAngles();
        const helpAngle = this.state.currentInstructionAngle;
        const expandedAngle = angles.find(a => Number(a.id) === Number(this.state.expandedAngleId));
        const noAngleVideos = this.getVideosForAngle(videos, 0);

        const modals = (
            <ModalRoot activeModal={this.state.activeModal}>
                <ModalPage settlingHeight={100} id={MODAL_VIDEO_HELP} onClose={this.modalBack}
                           header={
                               <ModalPageHeader
                                   after={<PanelHeaderButton aria-label="Закрыть"
                                                             onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}>
                                   Как снимать{helpAngle ? `: ${helpAngle.title}` : ''}
                               </ModalPageHeader>
                           }>
                    {helpAngle &&
                        <Div>
                            {Array.isArray(helpAngle.examples) && helpAngle.examples.length > 0 &&
                                <>
                                    <Title level="3" style={{marginBottom: 8}}>Примеры</Title>
                                    <div style={{display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16}}>
                                        {helpAngle.examples.map((example, i) => (
                                            <a key={`help-vex-${helpAngle.id}-${i}`} href={videosUrl + example}
                                               target="_blank" rel="noreferrer">
                                                <img src={videosUrl + example} alt="Пример"
                                                     style={{height: 120, borderRadius: 6}}/>
                                            </a>
                                        ))}
                                    </div>
                                </>}
                            {helpAngle.instruction_pdf &&
                                <Button mode="primary" size="m"
                                        onClick={() => this.openAngleInstruction(helpAngle)}>
                                    Открыть PDF-инструкцию
                                </Button>}
                        </Div>}
                    {!helpAngle &&
                        <Div>
                            <p>Пройдите по рядам с образцами товаров и снимите, как выставлены стенды.</p>
                            {!this.props.isOffline &&
                                <div style={{marginTop: 12}}>
                                    <Title level="3">Пример видео</Title>
                                    <video controls preload="none" playsInline
                                           width={AdaptivityContext.isMobile ? 260 : 400}
                                           style={{borderRadius: 8, maxWidth: '100%'}}
                                           src={videosUrl + '/uploads/manuals/monitoring_video_example.mp4'}/>
                                </div>}
                            <Button mode="primary" size="m" style={{marginTop: 12}}
                                    onClick={() => this.setActiveModal(MODAL_VIDEO_INSTRUCTION)}>
                                Открыть PDF-инструкцию
                            </Button>
                        </Div>}
                </ModalPage>
                <ModalPage settlingHeight={100} id={MODAL_VIDEO_INSTRUCTION} onClose={this.modalBack}
                           header={
                               <ModalPageHeader
                                   after={<PanelHeaderButton aria-label="Закрыть"
                                                             onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}>
                                   PDF{helpAngle ? `: ${helpAngle.title}` : ''}
                               </ModalPageHeader>
                           }>
                    <PDFViewer file={helpAngle && helpAngle.instruction_pdf
                        ? videosUrl + helpAngle.instruction_pdf
                        : videosUrl + '/react/VideoInstruction.pdf'}/>
                </ModalPage>
                {angles.length > 0 &&
                    <ModalPage settlingHeight={50} id={MODAL_CHANGE_VIDEO_ANGLE} onClose={this.modalBack}
                               header={
                                   <ModalPageHeader
                                       after={<PanelHeaderButton aria-label="Закрыть"
                                                                 onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}>
                                       Укажите ракурс
                                   </ModalPageHeader>
                               }>
                        <Div>
                            {angles.map(angle => (
                                <SimpleCell
                                    key={`change-vangle-${angle.id}`}
                                    onClick={() => this.applyChangeVideoAngle(angle.id)}
                                >
                                    {angle.title}
                                </SimpleCell>
                            ))}
                            <SimpleCell onClick={() => this.applyChangeVideoAngle(0)}>
                                Без ракурса
                            </SimpleCell>
                        </Div>
                    </ModalPage>}
            </ModalRoot>
        );

        return (
            <SplitLayout modal={modals}>
                <SplitCol>
                    <PanelHeader fixed={true}>
                        <Div>
                            Мониторинг точки. Шаг 3. Видео
                        </Div>
                    </PanelHeader>

                    {this.props.isOffline &&
                        <Chip style={{float: 'right'}} removable={false} className="all-docs"
                              id="is_offline">Offline режим<HelpButton
                            text={"Нет связи с интернет. Работаем в автономном режиме"}/></Chip>}

                    {angles.length > 0 &&
                        <>
                            <div className="angle-tiles">
                                {angles.map(angle => this.renderAngleTile(angle, videos, videosUrl))}
                            </div>
                            {this.renderExpandedAngle(expandedAngle, videos, videosUrl)}

                            {/* Always mounted off-layout so action-board camera can open capture with angle select */}
                            <div style={{position: 'absolute', left: -9999, width: 1, height: 1, overflow: 'hidden'}}>
                                <TakeAVideo
                                    ref={ref => this.noAngleVideoRef = ref}
                                    destination="brands"
                                    url={videosUrl}
                                    angles={angles}
                                    eventName="setSalePointMonitoringVideo"
                                    label="Снять видео"
                                />
                            </div>

                            {noAngleVideos.length > 0 &&
                                <Div>
                                    <Title level="3">Без ракурса</Title>
                                    <div style={{display: 'flex', flexWrap: 'wrap', gap: 12}}>
                                        {noAngleVideos.map(({item, index}) => this.renderVideoCard(item, index, angles))}
                                    </div>
                                </Div>}
                        </>}

                    {angles.length === 0 &&
                        <Div>
                            <div style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8}}>
                                <Title level="3" style={{margin: 0}}>Видео торговой точки</Title>
                                <Button mode="tertiary" size="s"
                                        before={<Icon24QuestionOutline width={22} height={22}/>}
                                        onClick={() => {
                                            this.setState({currentInstructionAngle: null});
                                            this.setActiveModal(MODAL_VIDEO_HELP);
                                        }}
                                        aria-label="Как снимать"/>
                            </div>
                            <div style={{display: 'flex', flexWrap: 'wrap', gap: 12}}>
                                {videos.map((item, index) => this.renderVideoCard(item, index, angles))}
                            </div>
                            <div style={{marginTop: 8}}>
                                <TakeAVideo
                                    ref={ref => this.freeformVideoRef = ref}
                                    destination="brands"
                                    url={videosUrl}
                                    angles={angles}
                                    eventName="setSalePointMonitoringVideo"
                                />
                            </div>
                        </Div>}

                    <Div className="action-board">
                        <ButtonGroup mode="horizontal" stretched>
                            <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                    onClick={() => setQuizStep(2, 'SalePointMonitoring')}>Назад</Button>
                            <Button mode="outline" size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                    onClick={this.openGreenCamera}><Icon24Video/></Button>
                            <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                    onClick={() => this.nextStep()}>Далее</Button>
                        </ButtonGroup>
                    </Div>
                </SplitCol>
            </SplitLayout>);
    }
}

export default withOffline(SalePointMonitoringStepVideo)
